import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Link } from "gatsby"

import Obr from "../images/katherine-volkovski-Q_MJjEN14uk-unsplash.jpg"
import Abramia from "../images/david-holifield-4SLhp1olvFc-unsplash.jpg"

const ThirdPage = () => (
  <Layout>
    <SEO title="Hybridy kukurice" />
    <section className="text-gray-700 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-col text-center w-full mb-20">
          <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
            Naše hybridy kukurice
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean et
            est a dui semper facilisis. Pellentesque placerat elit a nunc.
            Nullam tortor odio, rutrum quis, egestas ut, posuere sed, felis.
            Vestibulum placerat feugiat nisl. Suspendisse lacinia, odio non
            feugiat vestibulum, sem erat blandit metus, ac nonummy magna odio
            pharetra felis. Vivamus vehicula velit non metus faucibus auctor.
          </p>
        </div>
        <div className="flex flex-wrap -m-2">
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-abramia"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-300">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Abramia}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Abramia
                  </h2>
                  <p className="text-gray-500">FAO 450</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-citrinia"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-100">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Obr}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Citrinia
                  </h2>
                  <p className="text-gray-500">FAO 210</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-erytrinia"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-300">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Abramia}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Erytrinia
                  </h2>
                  <p className="text-gray-500">FAO 270</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-pyroxenia"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-100">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Obr}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Pyroxenia
                  </h2>
                  <p className="text-gray-500">FAO 130</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-rodonia"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-300">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Abramia}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Rodonia
                  </h2>
                  <p className="text-gray-500">FAO 360</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-serbilia"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-100">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Obr}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Serbilia
                  </h2>
                  <p className="text-gray-500">FAO 450</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-stroncia"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-300">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Abramia}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Stroncia
                  </h2>
                  <p className="text-gray-500">FAO 320</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-tirnavia"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-100">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Obr}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Tirnavia
                  </h2>
                  <p className="text-gray-500">FAO 280</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-tyrkenzia"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-300">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Abramia}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Tyrkenzia
                  </h2>
                  <p className="text-gray-500">FAO 180</p>
                </div>
              </div>
            </Link>
          </div>

          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-zirkonia"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-100">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Obr}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Zirkonia
                  </h2>
                  <p className="text-gray-500">FAO 260</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-zeta140s"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-300">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Abramia}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Zeta 140 S
                  </h2>
                  <p className="text-gray-500">FAO 140</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-zeta200s"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-100">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Obr}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Zeta 200 S
                  </h2>
                  <p className="text-gray-500">FAO 200</p>
                </div>
              </div>
            </Link>
          </div>

          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-zeta250g"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-300">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Abramia}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Zeta 250 G
                  </h2>
                  <p className="text-gray-500">FAO 250</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-zeta300g"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-100">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Obr}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Zeta 300 G
                  </h2>
                  <p className="text-gray-500">FAO 300</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="p-2 lg:w-1/3 md:w-1/2 w-full">
            <Link
              to="/hybrid-kukurice-zeta325g"
              className="text-gray-600 hover:text-gray-800"
            >
              <div className="h-full flex items-center border-gray-400 border p-4 rounded-lg bg-gray-300">
                <img
                  alt="team"
                  className="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"
                  src={Abramia}
                />
                <div className="flex-grow">
                  <h2 className="text-gray-900 title-font font-medium">
                    Zeta 325 G
                  </h2>
                  <p className="text-gray-500">FAO 325</p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  </Layout>
)

export default ThirdPage
